/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Trips_Nudge_DescInputs */

const en_ui_trips_nudge_desc = /** @type {(inputs: Ui_Trips_Nudge_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle related outings and revisit them together on the map`)
};

const de_ui_trips_nudge_desc = /** @type {(inputs: Ui_Trips_Nudge_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bündle zusammengehörige Ausfahrten und sieh sie gemeinsam auf der Karte`)
};

/**
* | output |
* | --- |
* | "Bundle related outings and revisit them together on the map" |
*
* @param {Ui_Trips_Nudge_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trips_nudge_desc = /** @type {((inputs?: Ui_Trips_Nudge_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trips_Nudge_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trips_nudge_desc(inputs)
	return de_ui_trips_nudge_desc(inputs)
});